module.exports = __webpack_public_path__ + "media/images/elionline/icons/side_menu_correggere_attivo-90dd285444734951fd8616932d8a0a27.svg";